import { render, staticRenderFns } from "./ResetSector.vue?vue&type=template&id=71e13583&"
import script from "./ResetSector.vue?vue&type=script&lang=js&"
export * from "./ResetSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports